<template>
	<ParamWrapper v-bind="wrapperProps" @input-data-closed="onDataInputMenuClose">
		<component :is="component" v-bind="componentProps" v-on="componentListeners" />
		<template v-slot:input-data>
			<slot name="input-data">
				<StringDataInputMenu :param="param" v-on="dataInputListeners" ref="data-input-menu" />
			</slot>
		</template>
		<UserMatchingFallbackModal
			v-if="userMatchingFallbackModalProps.appInfo"
			v-bind="userMatchingFallbackModalProps"
			v-on="userMatchingFallbackModalListeners"
		/>
	</ParamWrapper>
</template>

<script>
import StringDataInputMenu from '../DataInputMenus/StringDataInputMenu';
import ParamTypeMixin from './mixins/ParamTypeMixin';
import ExternalSourceMixin from './mixins/ExternalSourceMixin';
import UserMatchingMixin from './mixins/UserMatchingMixin';
import IsTextAreaMixin from './mixins/ParamPropertiesMixins/IsTextAreaMixin';
import ParamTypeExtenderDataInputMenuMixin from './mixins/ParamTypeExtenderDataInputMenuMixin';
import ThisFlowMixin from './mixins/ThisFlowMixin';
import DefaultPropertyInput from '../inputsComponents/DefaultPropertyInput';
import DefaultPropertyDropdownInput from '../inputsComponents/DefaultPropertyDropdownInput';
import ParamTypeHelper from './param-type-helper';
import { TEXT_BOX_FORMAT_TYPES } from '@/components/common/RichTextBox/rich-text-box.const';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
export default {
	name: 'StringParamType',
	mixins: [ParamTypeMixin, ParamTypeExtenderDataInputMenuMixin, ThisFlowMixin, ExternalSourceMixin, UserMatchingMixin, IsTextAreaMixin],
	components: { StringDataInputMenu, DefaultPropertyInput, DefaultPropertyDropdownInput },
	props: {
		acceptSingleValue: { type: Boolean },
		forceTemplateValue: { type: Boolean },
		templateValue: { type: [String, Array, Number, Object] },
	},
	methods: {},
	computed: {
		componentConfig() {
			const DROPDOWN_INPUT_PROPS = {
				...this.$attrs,
				ref: 'richEditor',
				value: this.localValueDisplay,
				loading: this.loading,
				readonly: this.readonly,
				rules: this.fieldRules,
				inputFieldHint: this.param.placeholder,
				isUserMatching: this.isUserMatching,
				showClearButton: !isNullOrUndefinedOrEmpty(this.localValueDisplay),
				isDropdownOpen: this.showDataMenu,
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
			};
			const RICH_TEXT_BOX_PROPS = {
				...this.buildCommonRichTextBoxProps(),
				...this.$attrs,
				ref: 'richEditor',
				inputFieldHint: this.param.placeholder,
				textAreaMode: this.isTextArea,
				value: this.forceTemplateValue ? this.templateValue : this.templateValue || this.localValue,
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
				richTextFormat: this.param.format || TEXT_BOX_FORMAT_TYPES.PLAIN_TEXT,
				fixPlusButtonPad: Boolean(this.param.extra_text),
				readonly: this.readonly,
			};
			const DROPDOWN_INPUT_LISTENERS = {
				'clear-value': this.clearValue,
				'open-user-matching-dialog': this.openUserMatchingDialog,
				focus: this.onInputFocus,
				blur: this.onInputBlur,
				open: this.openDataInputMenu,
				click: this.onInputClick,
			};
			const RICH_TEXT_BOX_LISTENERS = {
				focus: this.onInputFocus,
				click: () => this.onInputClick(true),
				blur: this.onInputBlur,
				open: this.openDataInputMenu,
				input: (val) => (this.localValue = val),
				'content-updated': this.onContentUpdate,
			};

			const REGULAR_PROPERTY_INPUT_CONFIG = ParamTypeHelper.buildComponentConfigItem(
				DefaultPropertyInput,
				RICH_TEXT_BOX_PROPS,
				RICH_TEXT_BOX_LISTENERS
			);
			const REGULAR_PROPERTY_DROPDOWN_INPUT_CONFIG = ParamTypeHelper.buildComponentConfigItem(
				DefaultPropertyDropdownInput,
				DROPDOWN_INPUT_PROPS,
				DROPDOWN_INPUT_LISTENERS
			);
			return this.fromExternalSource ? REGULAR_PROPERTY_DROPDOWN_INPUT_CONFIG : REGULAR_PROPERTY_INPUT_CONFIG;
		},
		component() {
			return this.componentConfig.component;
		},
		componentProps() {
			return this.componentConfig.props;
		},
		componentListeners() {
			return this.componentConfig.listeners;
		},
	},
	data() {
		return {};
	},
	watch: {
		componentConfig: {
			handler() {
				this.$nextTick(() => {
					this.setInputElement(this.$refs['richEditor']?.$el);
				});
			},
		},
		templateValue(newV) {
			if (this.forceTemplateValue) {
				this.localValue = newV;
			}
		},
	},
	mounted() {
		if (this.acceptSingleValue) {
			this.setReplaceValueOnSelection(true);
			this.setDisableCustomMultipleSelectionSupport(true);
		}
		if (this.templateValue && this.forceTemplateValue) {
			this.localValue = this.templateValue;
		}
	},
};
</script>
<style lang="scss" scoped></style>
